/**
 * Space activation for the header search trigger.
 *
 * `#SearchOpen` carries `role="button"` and so must activate on Enter *and*
 * Space. It is an `<a href>` underneath: Enter comes free from the link, Space
 * does not (on a link it scrolls the page), so it is bound here.
 *
 * A plain `defer` script, not an Alpine `@keydown.space` binding: the theme
 * defers most of its JS until the first mouseover / touchstart, neither of which
 * a keyboard-only user fires — an Alpine-bound Space key would be dead for
 * exactly the population this is for. Binds on parse.
 *
 * Delegated on `document` because there are three `#SearchOpen` copies: the two
 * pre-ajax placeholders in `sections/header.liquid` and the one in
 * `snippets/header-search-block.liquid`, which replaces a placeholder's
 * `innerHTML` once `xHeaderMenu.renderAjax` runs. Delegation survives that swap.
 *
 * `click()` matches Enter at both stages: before hydration it follows the href
 * to the search page, after it Alpine's `@click.prevent` opens the dialog.
 */
(() => {
  'use strict';

  document.addEventListener('keydown', (event) => {
    // Space only — Enter is the link's own activation and re-handling it here
    // would fire the trigger twice.
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;

    const trigger = event.target.closest?.('#SearchOpen');
    if (!trigger) return;

    // The panel's controls live in a sibling element, not inside the trigger, so
    // no field's space key is swallowed today. Guarded in case that changes.
    const tag = event.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || event.target.isContentEditable) return;

    event.preventDefault();
    trigger.click();
  });
})();
